<template>
  <v-switch
    color="blue darken-2"
    inset
    v-model="$vuetify.theme.dark"
    @change="setDark()"
    :label="`Dark theme`"
  ></v-switch>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "ThemeToggle",
  methods: {
    ...mapActions(["setDarkTheme"]),

    async setDark() {
      console.log(" -- Setting Dark Theme");
      console.log(this.$vuetify.theme.dark);
      await this.setDarkTheme(this.$vuetify.theme.dark);
    },
  },
};
</script>

<style lang="sass" scoped>
</style>